export const addRecord = (state, action, type) => {
  const { data: { data } } = action
  const { id } = data
  const jsonNormalizedRecord = { id, ...data.attributes }
  const newState = { ...state }

  newState[type] = [...state[type], jsonNormalizedRecord]
  return newState
}

export const setRecords = (state, action, type) => {
  const {
    data: {
      data
    },
  } = action

  const jsonNormalizedRecords = data.map((r) => {
    const { id } = r
    return { id, ...r.attributes }
  })

  const newState = { ...state }

  newState[type] = jsonNormalizedRecords
  return newState
}

export const editRecord = (state, action, type) => {
  const {
    data: {
      data
    },
  } = action
  const { id } = data
  const jsonNormalizedRecord = { id, ...data.attributes }

  const newState = { ...state }

  const updatedRecords = state[type].map((r) => {
    if (r.id === id) {
      return jsonNormalizedRecord
    }
    return r
  })

  newState[type] = updatedRecords

  return newState
}

export const removeRecord = (state, action, type) => {
  const { id } = action
  const newState = { ...state }

  const updatedRecords = state[type].filter(r => (r.id !== id))
  newState[type] = updatedRecords

  return newState
}



// WEBPACK FOOTER //
// ./src/utils/reducerUtils.js